export enum PRODUCT_LABEL {
  NEW = 'NEW',
  DEPRECATED = 'DEPRECATED',
  DISCONTINUED = 'DISCONTINUED',
  RECOMMENDED = 'RECOMMENDED',
  LABS = 'LABS',
  UPGRADE = 'UPGRADE',
  FREE = 'FREE',
  REALTIME_SCALING = 'REALTIME_SCALING',
}
